import React from "react";
import Modal from "./Modal";
import { Button, Typography } from "@mui/material";

const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  body,
  buttonLabel,
  buttonLabelSecondary,
  buttonStyle,
  loading,
  hideButton = false,
  width
}) => {
  return (
    <Modal
      open={show}
      width={width || "sm"}
      handleClose={() => {
        if (!loading) handleClose();
      }}
      modalTitle={title || "Confirm"}
      action={
        hideButton
          ? null
          : () => (
              <>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  disabled={loading}
                  title={buttonLabelSecondary || "Cancel"}
                >
                  {buttonLabelSecondary || "Cancel"}
                </Button>
                <Button
                  color={buttonStyle || "error"}
                  variant="contained"
                  onClick={handleConfirm}
                  disabled={loading}
                  title={buttonLabel || "Confirm"}
                >
                  {buttonLabel || "Confirm"}
                </Button>
              </>
            )
      }
    >
      <div style={{ minHeight: '80px' }}>
        {typeof body === 'string' ? (
          <Typography variant="body2">
            {body || "Are you sure you want to proceed?"}
          </Typography>
        ) : (
          body || <Typography variant="body2">Are you sure you want to proceed?</Typography>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
